import { BasketErrorModel } from './BasketErrorModel';
import { AxiosError } from 'axios';

export class BasketApiErrorModel extends BasketErrorModel {
    public requestUrl: string | null;
    public requestMethod: string | null;
    public responseStatus: number | null;
    public responseData: string | null;

    constructor(error: AxiosError, source: string) {
        super(
            error.message,
            undefined,
            source,
            [
                { key: 'requestUrl', value: error.config.url ?? null },
                { key: 'requestMethod', value: error.config.method ?? null },
                { key: 'responseStatus', value: error.response?.status ?? null },
                { key: 'responseData', value: error.response?.data ?? null }
            ]
        );

        this.requestUrl = error.config.url ?? null;
        this.requestMethod = error.config.method ?? null;
        this.responseStatus = error.response?.status ?? null;
        this.responseData = error.response?.data ?? null;
    }
}

export function isApiError(error: any): boolean {
    return error.isAxiosError;
}